module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout 404 */

(function(fox) {
	fox.registerWidget('Table', {

		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				externalLoad: false
			});
			
			this.callParent('configure', arguments);
		},

		getData: function () {
			this.dl.load();
		}

	}, 'Grid');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/table.js
// module id = 361
// module chunks = 2